import React from 'react';
import reactStringReplace from 'react-string-replace';
import InfoTooltip from './InfoTooltip';

export type FormatMessageProps = {
  children: string;
  tooltip?: string;
};

export function FormatMessage({ children, tooltip }: FormatMessageProps): React.ReactElement {
  let formattedMessage: string | React.ReactNodeArray = children;

  formattedMessage = reactStringReplace(formattedMessage, /(\n)/g, () => <br />);
  formattedMessage = reactStringReplace(formattedMessage, /<b>(.*)<\/b>/g, (match) => <span style={{ fontWeight: 'bold' }}>{match}</span>);
  formattedMessage = reactStringReplace(formattedMessage, /<i>(.*)<\/i>/g, (match) => <span style={{ fontStyle: 'italic' }}>{match}</span>);

  return (
    <div>
      {formattedMessage}
      {tooltip && <InfoTooltip size="mini" message={tooltip} />}
    </div>
  );
}
